import { generateClient } from 'aws-amplify/api'
import {
  formatGreetingMessage as formatGreetingMessageMutation,
  formatSystemPrompt as formatSystemPromptMutation,
} from '@/graphql/mutations'
import { parseAwsJson } from '@/utils/graphql'
import { getApiMessage } from '@/mixins/Extras/ApiResponse'

const client = generateClient()

function extractFormattedText(response, keys = []) {
  const payload = parseAwsJson(response) ?? response

  if (typeof payload === 'string') {
    return payload.trim()
  }

  if (!payload || typeof payload !== 'object') {
    return ''
  }

  const data = payload.data ?? payload.Data ?? payload

  for (const key of keys) {
    const value = data?.[key] ?? payload?.[key]
    if (value != null && String(value).trim()) {
      return String(value).trim()
    }
  }

  const fallback =
    data?.message ??
    data?.result ??
    data?.text ??
    payload?.message ??
    payload?.result ??
    payload?.text ??
    ''

  return String(fallback).trim()
}

export function extractFormattedGreetingMessage(response) {
  return extractFormattedText(response, [
    'greeting_message',
    'greetingMessage',
    'formatted_greeting_message',
    'formattedGreetingMessage',
    'greeting',
    'formatted_greeting',
    'formattedGreeting',
  ])
}

export function extractFormattedSystemPrompt(response) {
  return extractFormattedText(response, [
    'system_prompt',
    'systemPrompt',
    'formatted_system_prompt',
    'formattedSystemPrompt',
    'prompt',
    'formatted_prompt',
    'formattedPrompt',
  ])
}

export default {
  methods: {
    async formatGreetingMessage(input = {}) {
      try {
        const { data, errors } = await client.graphql({
          query: formatGreetingMessageMutation,
          variables: { input },
        })

        const parsed = parseAwsJson(data?.formatGreetingMessage)
        if (parsed != null) {
          return parsed
        }

        if (errors?.length) {
          throw new Error(errors[0].message)
        }

        return null
      } catch (error) {
        return {
          status: 'ERROR',
          message: getApiMessage(error, 'Failed to format greeting message'),
        }
      }
    },

    async formatSystemPrompt(input = {}) {
      try {
        const { data, errors } = await client.graphql({
          query: formatSystemPromptMutation,
          variables: { input },
        })

        const parsed = parseAwsJson(data?.formatSystemPrompt)
        if (parsed != null) {
          return parsed
        }

        if (errors?.length) {
          throw new Error(errors[0].message)
        }

        return null
      } catch (error) {
        return {
          status: 'ERROR',
          message: getApiMessage(error, 'Failed to format system prompt'),
        }
      }
    },
  },
}
